import { attr, fk } from 'redux-orm';

import BaseModel from './BaseModel';
import ActionTypes from '../constants/ActionTypes';

export default class extends BaseModel {
  static modelName = 'CardPointArchivedData';

  static fields = {
    id: attr(),
    type: attr(),
    typeTitle: attr(),
    typeValue: attr(),
    viewsBase: attr(),
    viewsReal: attr(),
    coefficient: attr(),
    taskCreatedAt: attr(),
    taskClosedAt: attr(),
    cpdId: fk({
      to: 'CardPointData',
      as: 'cardPointData',
      relatedName: 'cardPointArchivedDatas',
    }),
    pointSistemId: fk({
      to: 'PointSystem',
      as: 'pointSystem',
      relatedName: 'cardPointArchivedDatas',
    }),
  };

  static reducer({ type, payload }, CardPointArchivedData) {
    switch (type) {
      case ActionTypes.CARD_POINT_DATA_COMPLETE__SUCCESS:
        if (payload.archivedItem) {
          CardPointArchivedData.upsert(payload.archivedItem);
        }

        break;
      case ActionTypes.CARD_POINT_ARCHIVED_DATA_DELETE__SUCCESS:
        if (payload.archivedItem && payload.archivedItem.id) {
          CardPointArchivedData.withId(payload.archivedItem.id).delete();
        }

        break;
      default:
    }
  }
}

